import React from 'react';
import { Hero } from './components/Hero';
import { StatsBand } from './components/StatsBand';
import { ProblemSection } from './components/ProblemSection';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-sky font-sans text-navy selection:bg-coral selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <StatsBand data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <ModulesSection data-id="element-4" />
      <PricingSection data-id="element-5" />
      <FAQSection data-id="element-6" />
      <Footer data-id="element-7" />
    </div>;
}